import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  LinearProgress,
  Grid,
  IconButton
} from "@mui/material";
import { BsGearFill, BsPencilSquare, BsTrashFill } from "react-icons/bs";
import Swal from "sweetalert2";
import usericon from './user.png'
export default function InfoCard({ img_type, icon, type, data, onClick, keys, onAction = () => { } }) {
  const cols = type === "user" ? [2, 10] : [4, 8];
  const handleClick = onClick || (() => { });

  const avatar = (type, data, keys) => {
    const imageSrc = data[keys[0]];
    if (type === "user") {
      return (
        <Box
          component="img"
          src={usericon}
          loading="lazy"
          alt=""
          sx={{
            width: 40,
            objectFit: "cover",
            borderRadius: 2,
            maxHeight: 64,
          }}
        />
      );
    }
    return (
      <Box
        component="img"
        src={imageSrc}
        loading="lazy"
        alt=""
        onError={(e) => { e.target.style.display = 'none'; }}
        sx={{
          width: 40,
          maxWidth: 200,
          height: "auto",
          maxHeight: 64,
          objectFit: "cover",
          borderRadius: 2
        }}
      />
    );
  };

  return (
    <Card
      sx={{
        // backgroundColor: "#ebebeb",
        borderRadius: 4,
        p: 2,
        cursor: "pointer",
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
      }}
      onClick={handleClick}
      className="input-label"
    >
      <Grid container spacing={2}>
        <Grid item size={{ md: cols[0] }}>
          {icon ? icon : avatar(type, data, keys)}
        </Grid>
        <Grid item size={{ md: cols[1] }}>
          <Box>
            <Typography fontWeight={800}>{data[keys[1]]}</Typography>
            <Typography variant="body2">{data[keys[2]]}</Typography>
            <Typography variant="body2">{data[keys[3]]}</Typography>
          </Box>
        </Grid>
      </Grid>
      <Box sx={{ my: 1, fontSize: 12 }}>
        {data[keys[4]]}
      </Box>
      <CardContent sx={{ p: 0, display: "flex", justifyContent: "space-between", mt: 'auto' }}>

        <Box sx={{ fontSize: "0.9em" }}>
          <Typography variant="body2">{data[keys[5]]}</Typography>
          <Typography variant="subtitle2">Created At:</Typography>
          <Typography variant="body2">{data[keys[6]]}</Typography>
        </Box>
        <Box sx={{ fontSize: "0.9em" }}>
          <Typography variant="subtitle2">
            {data[keys[7]] ? "User:" : "Action"}{data[keys[7]]}
          </Typography>
          <Typography variant="body2">{data[keys[8]]}</Typography>
          <IconButton onClick={() => onAction("Settings", data)} size="small">
            <BsGearFill />
          </IconButton>
          <IconButton onClick={() => onAction("Edit", data)} size="small">
            <BsPencilSquare />
          </IconButton>
          <IconButton
            onClick={(e) => {
              e.stopPropagation(); // Prevent card click
              Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, delete it!"
              }).then((result) => {
                if (result.isConfirmed) {
                  onAction("Delete", data);
                }
              });
            }}
            size="small"
          >
            <BsTrashFill />
          </IconButton>
        </Box>
      </CardContent>
    </Card>
  );
}
